import React, { Component } from 'react';
import ReactTelInput from 'react-telephone-input';
import axios from 'axios';
import { Async } from 'react-select';

// Styles
import '../../../node_modules/react-select/dist/react-select.css';

const SendIcon = () => {
  return (
    <svg fill="#fff" height="24" viewBox="0 0 24 24" width="24">
      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
      <path d="M0 0h24v24H0z" fill="none"/>
    </svg>
  );
}

const ErrorIcon = () => {
  return (
    <svg fill="#c12d2d" height="20" viewBox="0 0 24 24" width="20">
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
    </svg>
  )
}

const SuccessIcon = () => {
  return (
    <svg fill="#3c763d" height="20" viewBox="0 0 24 24" width="20">
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>
    </svg>
  )
}

class Form extends Component {
  state = {
    channelUuid: window.location.pathname.split('/form/')[1],
    data: this.props.data || null,
    selectedConversationType: '',
    telephoneValue: '',
    emailValue: '',
    nameValue: '',
    messageValue: '',
    inputsInvalid: false,
    formSubmitted: false,
    loading: true,
  }

  componentWillMount() {
    this.initializeApp();
  }

  initializeApp = () => {
    this._fetchChannel(this.state.channelUuid)
    .catch(this.showErrorMessage)
    .then(channel => {
      this._fetchConversationTypes(channel.account.uuid, this.state.channelUuid)
        .catch(this.showErrorMessage)
        .then(conversationTypes => {
          const data = Object.assign(channel, { conversationTypes });
          this.setState({
            loading: false,
            data,
          });
        });
    });
  }

  _fetchChannel(uuid) {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/channel/${uuid}`)
      .then(res => res.data);
  }

  _fetchConversationTypes(accountUuid, channelUuid) {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/conversation-types/${accountUuid}/${channelUuid}`)
      .then(res => res.data);
  }

  showErrorMessage = (error) => {
    console.log(error);
  }

  handleConversationTypeChange = (selectedConversationType) => {
    this.setState({
      selectedConversationType,
    });
  }

  onSubmitForm = () => {
    if (this.checkFormValidity()) {
      axios.post(`${process.env.REACT_APP_API_URL}/send-email`, {
        sendEmailTo: this.state.data.account.contact_email,
        name: this.state.nameValue,
        subject: this.state.selectedConversationType.label,
        email: this.state.emailValue,
        phone: this.state.telephoneValue,
        message: this.state.messageValue,
      })
      .then(res => res.data)
      .then(res => {
        this.setState({
          formSubmitted: true,
          selectedConversationType: '',
          telephoneValue: '',
          emailValue: '',
          nameValue: '',
          messageValue: '',
          inputsInvalid: false,
        });
      });
    }
  }

  checkFormValidity() {
    if (
      (
        this.state.data.data.authMethod && this.state.data.data.authMethod === "phone" ? 
          (this.state.telephoneValue.trim().length > 0 && this.state.telephoneValue.length <= 17) :
        (this.state.emailValue.trim().length > 0 && this.checkEmail(this.state.emailValue))
      ) &&
      this.state.nameValue.trim().length > 0 &&
      this.state.messageValue.trim().length > 0
    ) {
      this.setState({
        inputsInvalid: false,
      });

      return true;
    } else {
      this.setState({
        inputsInvalid: true,
      });

      return false;
    }
  }

  onTelephoneInputChange = (telNumber, selectedCountry) => {
    if (selectedCountry.dialCode === "90") {
      if (telNumber.length <= 17) {
        this.setState({
          telephoneValue: telNumber,
          isPhoneNumberValid: true,
        });
      } else {
        this.setState({
          isPhoneNumberValid: false,
        });
      }
    } else {
      this.setState({
        telephoneValue: telNumber,
        isPhoneNumberValid: true,
      });
    }
  }

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  // Check the email address, if is it valid, start the conversation using that
  checkEmail = (email) => {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // Check the email adress
    if (emailRegex.test(String(email).toLowerCase())) {
      return true;
    }

    return false;
  }

  render () {
    return (
      this.state.loading ? 
      <div className="loading"></div> :
      <div className="form-wrapper">
        <div
          className="form-header"
          style={{
            background: `linear-gradient(to left, ${this.state.data.data.baseColor.hex} 0%, rgba(${this.state.data.data.baseColor.rgb.r}, ${this.state.data.data.baseColor.rgb.g}, ${this.state.data.data.baseColor.rgb.b}, 0.6) 100%)`,
          }}
        >
          <div className="company-image">
            {this.state.data.data.logo ? (
              <img src={this.state.data.data.logo} alt=""/>
            ) : (
              <span
                style={{
                  color: this.state.data.data.baseColor.hex,
                  fontSize: '20px',
                  fontWeight: 900,
                }}
              >
                {this.state.data && this.state.data.name[0]}
              </span>
            )}
          </div>
          <span>
            {
              this.state.data &&
              this.state.data.name
            }
          </span>
        </div>
        <div className="form-caption">
          <div className="description">
            <h2>Merhaba!</h2>
            <p>Şu an mesai saatleri dışındayız. Mesajınızı alt taraftaki formu kullanarak iletebilirsiniz.</p>
          </div>
          <div className="input-group">
            {this.state.inputsInvalid ? (
              <div className="message-box error">
                <ErrorIcon /> Tüm alanların doldurulması zorunludur!
              </div>
            ) : null}
            {this.state.formSubmitted ? (
              <div className="message-box success">
                <SuccessIcon /> Mesajınız gönderilmiştir.
              </div>
            ) : null}
            <div className="input">
              <span>İsim Soyisim</span>
              <input
                value={this.state.nameValue}
                name="nameValue"
                type="text"
                onChange={this.onInputChange} 
              />
            </div>
            <div className="input">
              <span>Konu</span>
              <Async
                name="conversation-type-selector"
                value={this.state.selectedConversationType}
                placeholder="Konu seçiniz..."
                onChange={this.handleConversationTypeChange}
                loadOptions={(input, callback) => {
                  const options = this.state.data.conversationTypes.map((conversationType) => {
                    return {
                      value: conversationType.slug,
                      label: conversationType.name,
                    };
                  });

                  callback(null, {
                    options,
                    complete: true,
                  });
                }}
              />
            </div>
            {this.state.data.data.authMethod &&
              this.state.data.data.authMethod === "phone" ? (
                <div className="input">
                  <span>Telefon</span>
                  <ReactTelInput
                    defaultCountry="tr"
                    onChange={this.onTelephoneInputChange}
                    isValid={() => this.state.isPhoneNumberValid}
                    placeholder={
                      'Write your phone number'
                    }
                    value={this.state.telephoneValue}
                    flagsImagePath='/flags.png'
                  />
                </div>
            ) : (
              <div className="input">
                <span>Email</span>
                <input
                  value={this.state.emailValue}
                  name="emailValue"
                  type="text"
                  onChange={this.onInputChange} 
                />
              </div>
            )}
            <div className="input">
              <span>Mesajınız</span>
              <textarea 
                height="100px"
                value={this.state.messageValue}
                name="messageValue"
                type="text"
                onChange={this.onInputChange} 
              ></textarea>
            </div>
            <div className="input submit">
              <button 
                onClick={() => { this.onSubmitForm(); }}
                disabled={this.state.formSubmitted}
              >
                Gönder <SendIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/Form.js